import { wfs3dRouteSelector } from "../../common/selector/configurationSelector";
import { getState } from "../../common/store/stateUtil";

export const selectDefaultRouteHeight = () => {
    return wfs3dRouteSelector(getState()).defaultHeight;
};

export const selectDefaultRouteWidth = () => {
    return wfs3dRouteSelector(getState()).defaultWidth;
};
